// #region Imports

import * as $ from 'jquery';
import { Toaster } from './ui/toaster';

// #endregion Imports

// #region Exports

export function initialize(): void {
    bindEvent();
}

// #endregion Exports

// #region Private functions

function bindEvent(): void {
    const inputSelector = '.js-ajax-post';
    $(inputSelector).on('submit', handleSubmit);
}

function handleSubmit(event): void {
    event.preventDefault();

    const $form = $(this);

    $.post(event.target.action, $form.serialize(), (response) => {
        $form.trigger('reset');
        Toaster.show(response.message, response.success);
    });
}

// #endregion Private functions